import { Modal } from "antd";
import React from "react";
import { validaRegistraObs } from "../../api/validacionOrg";
import { MSN_GUARDAR } from "../constanst";

export function modalConfirma(observaciones, setLoader, history) {
    let contentObs = <p>Se enviarán las observaciones al representante de la organización</p>;
    let contentVal = <div><p>La organización será validada</p><p>¿Deseas continuar?</p></div>;
    Modal.confirm({
        title: null,
        icon: null,
        content: observaciones.estatusValidacion === "valida" ? contentVal : contentObs,
        okText: observaciones.estatusValidacion === "valida" ? "Validar organización" : "Enviar observaciones",
        okButtonProps: { style: { width: "auto" } },
        cancelText: "Cancelar",
        onOk() {
            setLoader({ loading: true, message: MSN_GUARDAR }); //Se activa el loader
            enviaObservaciones(observaciones, setLoader, history);
        }
    });
}

function enviaObservaciones(observaciones, setLoader, history) {
    validaRegistraObs(observaciones).then((res) => {
        setLoader({ loading: false, message: "" }); //Se desactiva el loader
        if(res.data.code === 200) {
            Modal.success({
                title: "Estado de solicitud de organización",
                content: <p>{res.data.message}</p>,
                okText: "Aceptar",
                onOk() {
                  history.push("/admin/validacionOrg"); //Redirecciona a la pantalla principal del módulo
                },
            });
        } else {
            Modal.error({
                title: "Error",
                content: <p>{res.data.causa}</p>,
                onOk() {
                    history.push("/admin/validacionOrg"); //Redirecciona a la pantalla principal del módulo
                },
            });
        }
    }).catch((error) => {
        console.log("Error al registrar observaciones o validar la organización");
        console.log(error);
    });
}